import React, {useState, useEffect} from 'react'
import {MDBBadge, MDBCard} from "mdbreact";
import classes from './DetailCard.module.css'
import {faPlus, faQuestion, faThumbsDown, faThumbsUp} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

const DetailCard = (props) => {
    const [isDeleting, setIsDeleting] = useState(false)

    return(
        <MDBCard className={classes.DetailCard}>
            {
                props.isEditMode &&
                <button className={classes.DeleteImageBtn}
                        disabled={isDeleting}
                        onClick={() => {
                            setIsDeleting(true)
                            props.removeDetail(props.data.id)
                        }}>
                    X
                </button>
            }
            <div className={classes.DetailCardRow}>
                <div className={classes.VoteContainer}>
                    {
                        props.data.isUpvote === true ?
                            <FontAwesomeIcon className={classes.UpVote} icon={faThumbsUp}/> :
                            props.data.isUpvote === false ?
                                <FontAwesomeIcon className={classes.DownVote} icon={faThumbsDown}/> :
                                <FontAwesomeIcon icon={faQuestion}/>
                    }
                </div>
                <div className={classes.DetailCardContent}>
                    <div className={classes.Content}>
                        {props.data.content}
                    </div>
                    <div>
                        {
                            props.data.isAdmin &&
                                <MDBBadge color={'link'} className={classes.AdminBadge}>ADMIN</MDBBadge>
                        }
                    </div>

                </div>

            </div>

        </MDBCard>
    )
}
export default DetailCard